import axiosI from '../Service/service';
import { GET_BUSINESS_PROFILE } from './actionTypes';
import * as constants from '../Constants';

export const GetBusinessProfile=(userId,toUserId,lat,long)=>{
  return (dispatch => {

    return axiosI.get(`${constants.API.getUserProfileDetailApi}/${userId}/${toUserId}/${lat}/${long}`).then(({data})=>{
      dispatch({
        type:GET_BUSINESS_PROFILE,
        payload: data.results
      });
    })
  })
};
